/** The full miscellaneous-addition collection. */

import type { Misc } from '../../schema/misc';
import { miscAdditions } from './additions';

export { miscAdditions } from './additions';

/** Every misc addition in the catalog. */
export const miscs: readonly Misc[] = [...miscAdditions];
